/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visibilitymembersshort2Inputs */

const en_visibilitymembersshort2 = /** @type {(inputs: Visibilitymembersshort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Members`)
};

const de_visibilitymembersshort2 = /** @type {(inputs: Visibilitymembersshort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitglieder`)
};

/**
* | output |
* | --- |
* | "Members" |
*
* @param {Visibilitymembersshort2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const visibilitymembersshort2 = /** @type {((inputs?: Visibilitymembersshort2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visibilitymembersshort2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_visibilitymembersshort2(inputs)
	return de_visibilitymembersshort2(inputs)
});
export { visibilitymembersshort2 as "visibilityMembersShort" }